class UYRelatedProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.uyReady === 'true') return;
    this.dataset.uyReady = 'true';
    const track = this.querySelector('[data-related-track]');
    const prev = this.querySelector('[data-related-prev]');
    const next = this.querySelector('[data-related-next]');
    if (!track || !prev || !next) return;
    const amount = () => Math.max(track.clientWidth * 0.82, 280);
    const update = () => {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    requestAnimationFrame(update);
  }
}

if (!customElements.get('uy-related-products')) customElements.define('uy-related-products', UYRelatedProducts);

const initUYRelated = (root = document) => {
  root.querySelectorAll('product-recommendations.related-products').forEach((el) => {
    if (el.tagName.toLowerCase() === 'uy-related-products') return;
    // Product recommendations replace inner HTML asynchronously, so initialize after load.
    const setup = () => {
      const track = el.querySelector('[data-related-track]');
      if (!track || el.dataset.uyReady === 'true') return;
      el.dataset.uyReady = 'true';
      const prev = el.querySelector('[data-related-prev]');
      const next = el.querySelector('[data-related-next]');
      if (!prev || !next) return;
      const amount = () => Math.max(track.clientWidth * 0.82, 280);
      const update = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev.addEventListener('click', () => track.scrollBy({left:-amount(),behavior:'smooth'}));
      next.addEventListener('click', () => track.scrollBy({left:amount(),behavior:'smooth'}));
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      requestAnimationFrame(update);
    };
    setup();
    const observer = new MutationObserver(() => { setup(); if (el.querySelector('[data-related-track]')) observer.disconnect(); });
    observer.observe(el, {childList:true,subtree:true});
  });
};

document.addEventListener('DOMContentLoaded', () => initUYRelated());
document.addEventListener('shopify:section:load', (event) => initUYRelated(event.target));
